import React from 'react';
import { Button, Radio, Checkbox, Space, Card, Divider } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import CriteriaRow from './criteriaRow';

const CriteriaGroup = ({ 
  group, 
  onUpdate, 
  onDelete, 
  onCriteriaUpdate, 
  onAddCriteria, 
  onAddGroup, 
  onDeleteCriteria,
  level = 0, 
  parentLogicType,
  isSelectionCriteria = true,
  columnNames = [], 
  operators = [], 
  metadata = {},
  onColumnChange,
  isColumnLoading,
  isMetaDataLoading,
  columnTypes = {}
}) => {
  const getBackgroundColor = () => {
    const baseColors = ['#ffffff', '#f9f9f9', '#f0f0f0', '#e6e6e6', '#d9d9d9'];
    const baseColor = baseColors[level % baseColors.length];
    
    if (group.isNot) {
      return 'rgba(255, 0, 0, 0.05)';
    }
    
    return baseColor;
  };

  return (
    <Card 
      size="small"
      style={{ 
        marginBottom: 10,
        backgroundColor: getBackgroundColor(),
        borderColor: group.isNot ? 'rgba(255, 0, 0, 0.2)' : undefined
      }}
      title={
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Space>
         
            
            <Radio.Group
              size="small"
              value={group.logicType}
              onChange={(e) => onUpdate(group.id, 'logicType', e.target.value)}
              optionType="button"
              buttonStyle="solid"
            >
              <Radio.Button value="And">AND</Radio.Button>
              <Radio.Button value="Or">OR</Radio.Button>
            </Radio.Group>
            
            <Checkbox
              checked={group.isNot}
              onChange={(e) => onUpdate(group.id, 'isNot', e.target.checked)}
            >
              NOT
            </Checkbox>
          </Space>
          
          <Space>
            <Button
              type="default"
              icon={<PlusOutlined />}
              size="small"
              onClick={() => onAddCriteria(group.id)}
            >
              Add Rule
            </Button>
            <Button
              type="dashed"
              icon={<PlusOutlined />}
              size="small"
              onClick={() => onAddGroup(group.id)}
            >
              Add Group
            </Button>
            
            {level > 0 && (
              <Button
                type="text"
                danger
                icon={<DeleteOutlined />}
                size="small"
                onClick={() => onDelete(group.id)}
              />
            )}
          </Space>
        </div>
      }
      bordered={true}
    >
      <div className="group-content">
        {group.criteria.map((criteria, index) => (
          <React.Fragment key={criteria.id}>
            {index > 0 && (
              <Divider 
                plain
                orientation="center" 
                style={{ 
                  margin: '8px 0',
                  fontSize: '12px',
                  color: '#8c8c8c'
                }}
              >
                {group.logicType === 'Or' ? 'OR' : 'AND'}
              </Divider>
            )}
            
            {criteria.type === 'group' ? (
              <CriteriaGroup
                group={criteria}
                onUpdate={onUpdate}
                onDelete={onDelete}
                onCriteriaUpdate={onCriteriaUpdate}
                onAddCriteria={onAddCriteria}
                onAddGroup={onAddGroup}
                onDeleteCriteria={onDeleteCriteria}
                level={level + 1}
                parentLogicType={group.logicType}
                isSelectionCriteria={isSelectionCriteria}
                columnNames={columnNames}
                operators={operators}
                metadata={metadata}
                onColumnChange={onColumnChange}
                isColumnLoading={isColumnLoading}
                isMetaDataLoading={isMetaDataLoading}
                columnTypes={columnTypes}
              />
            ) : (
              <CriteriaRow
                criteria={criteria}
                onUpdate={(field, value) => onCriteriaUpdate(group.id, criteria.id, field, value)}
                onDelete={() => onDeleteCriteria(group.id, criteria.id)}
                columnNames={columnNames}
                operators={operators}
                metadata={metadata}
                onColumnChange={onColumnChange}
                isColumnLoading={isColumnLoading}
                isMetaDataLoading={isMetaDataLoading}
                columnTypes={columnTypes}
                isSelectionCriteria={isSelectionCriteria}
              />
            )}
          </React.Fragment>
        ))}
      </div>
    </Card>
  );
};

export default CriteriaGroup; 